import { createReducer } from 'reduxsauce';
import { MedicalGroupReducerTypes } from '../types';

import Types from './actions-types';

export const INITIAL_STATE: MedicalGroupReducerTypes = {
  list: [],
  pagination: {
    count: 8,
    total: 8,
    page: 1,
    filter: '',
    s: null,
  },
  isLoading: false,
  hasError: false,
};

export const createRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
  };
};

export const createRequestSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: false,
  };
};

export const createRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const listRequest = (state = INITIAL_STATE, action: any) => {
  return {
    ...state,
    pagination: { ...state.pagination, ...action.filters },
    isLoading: true,
  };
};

export const listRequestSuccess = (state = INITIAL_STATE, action: any) => {
  const { data, ...pagination } = action;

  return {
    ...state,
    list: data.data,
    pagination: { ...state.pagination, ...pagination },
    isLoading: false,
    hasError: false,
  };
};

export const listRequestError = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: false,
    hasError: true,
  };
};

export const clearStore = (state = INITIAL_STATE) => INITIAL_STATE;

export const HANDLERS = {
  [Types.MEDICAL_GROUPS_CREATE_REQUEST as string]: createRequest,
  [Types.MEDICAL_GROUPS_CREATE_REQUEST_SUCCESS as string]: createRequestSuccess,
  [Types.MEDICAL_GROUPS_CREATE_REQUEST_ERROR as string]: createRequestError,

  [Types.MEDICAL_GROUPS_LIST_REQUEST as string]: listRequest,
  [Types.MEDICAL_GROUPS_LIST_REQUEST_SUCCESS as string]: listRequestSuccess,
  [Types.MEDICAL_GROUPS_LIST_REQUEST_ERROR as string]: listRequestError,

  [Types.CLEAR_STORE as string]: clearStore,
};

export default createReducer(INITIAL_STATE, HANDLERS);
